import type { FaireProductEntity } from "../../entity_types/product";

export const p_dekscgag73: FaireProductEntity = {
  token: "p_dekscgag73",
  type: "product",
  name: "SURF SKATE SQUARE 02- LUNAR BLACK/YELLOW",
  brandToken: "b_9grp69f3nm",
  brandName: "Hydroponic",
  imageUrl:
    "https://cdn.faire.com/fastly/78d2bf5c9f736f6cb661cc9fc19c04ba26abb6d686029070303da7b64c99f550.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ad42853e70530ae7c7f0d84aa537855dda57c83b92417f58d321e77a6f5b50be.jpeg",
    "https://cdn.faire.com/fastly/ad519b09e6f26eeabb892a9967a32e59bc3314b1dda34969f209a40fc7668079.jpeg",
    "https://cdn.faire.com/fastly/6aa2590f05f7e21c97488d2481fd907ffe04995b1c8bcbbf322fdebd11e25d11.jpeg",
  ],
  priceDollars: 151.67,
  description:
    "“The Hydroponic SQUARE 02-Lunar Black has been manufactured with 7 plies of Canadian Hard Rock Maple and Epoxy Resin.\n\nSquare tail with nice concave and a pointy nose, allows you to skate transitions, pop ollies and do flatground tricks or just go up street curbs. A versatile deck that will skate anywhere you go. The Hydroponic SQUARE 02-Lunar Black lets you ride your skateboard as if you were truly surfing your board in the sea. You will need to position your weight on the back truck, so you can feel the 'Fin Effect' and gain stability while keeping the 360 turning sensations thanks to the rotating front truck. Once you achieve the perfect balance, your riding will instantly cross over! Great set up to perform close turns and breaks thanks to a variable Wheel Base, which makes avoiding street obstacles something easy and fun.",
  tags: [],
  msrpDollars: 303.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:42.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
